import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, message, Modal } from 'antd'
import humanizeTime from '../../../../helpers/time/humanizeTime'
import { Link } from "react-router-dom"
import BaskItemTypes from '../../../baskets/components/table/data/BaskItemTypes'
import BasketCompletedItem from '../../../baskets/components/table/data/BasketCompletedItem'
import BasketLocation from '../../../baskets/components/table/data/BasketLocation'
import BasketStatus from '../../../baskets/components/table/data/BasketStatus'
import BasketCreated from '../../../baskets/components/table/data/BasketCreated'
import { deleteDuplicateBasket } from '../../../../services/api/mergerApi'
import { getLocalData } from '../../../../services/StorageServices'
import { parseJwt } from '../../../../helpers/parseToken'

export default function BasketsDuplicateRow(props) {
    const { group, expanded, onToggle, resetData } = props
    const { basket_number, basket_location, docs = [], basket_total_items, count } = group || {}
    const docIds = docs.map(d => d._id)
    const [loadingAction, setLoadingAction] = useState(false)

    const handleDeleteBasket = async (basketInfo) => {
        const { _id } = basketInfo || {}
        setLoadingAction(true)
        try {
            const payload = {
                ids: [_id],
                is_force: true
            }
            const { data: res } = await deleteDuplicateBasket(payload)
            const { success, data, message: mess } = res || {}
            if (!success) {
                throw new Error(mess)
            }
            message.success(`Xóa giỏ thành công.`)
            resetData()
        } catch (error) {
            message.error(error.message || 'Xóa giỏ thất bại.')
        } finally {
            setLoadingAction(false)
        }
    }

    const attemptDeleteBasket = (basket) => {
        if (!basket) return

        const hasArrayOrders = Array.isArray(basket.order_numbers) && basket.order_numbers.length > 0
        const hasSingleOrder = !!basket.order_number
        const ordersList = hasArrayOrders ? basket.order_numbers : (hasSingleOrder ? [basket.order_number] : [])

        if (ordersList.length > 0) {
            Modal.confirm({
                title: 'Giỏ này đang chứa các mã đơn:',
                content: (
                    <div style={{ maxWidth: 420 }}>
                        <div style={{ fontFamily: 'monospace', wordBreak: 'break-all', fontWeight: 'bold' }}>
                            {ordersList.slice(0, 10).map((o, idx) => <div key={idx}>#{o}</div>)}
                            {ordersList.length > 10 && <div>... và {ordersList.length - 10} đơn khác</div>}
                        </div>
                        <i style={{ marginTop: 8, color: 'red', fontWeight: 'bold' }}>
                            Bạn có chắc chắn muốn xóa giỏ này không?
                        </i>
                    </div>
                ),
                okText: 'Tiếp tục xóa',
                cancelText: 'Hủy',
                okButtonProps: { danger: true, loading: loadingAction },
                onOk: () => handleDeleteBasket(basket)
            })
        } else {
            Modal.confirm({
                title: 'Bạn có chắc chắn muốn xóa giỏ?',
                content: 'Hành động này sẽ xóa giỏ. Vui lòng xác nhận.',
                okText: 'Có',
                cancelText: 'Không',
                okButtonProps: { danger: true, loading: loadingAction },
                onOk: () => handleDeleteBasket(basket)
            })
        }
    }

    const renderTypeBasket = (type = '') => {
        switch (type) {
            case 'normal':
                return 'Đơn thường'
            case 'combo_fac':
                return 'Combo FAC'
            case 'combine_ship':
                return 'Gộp ship'
            default:
                return ''
        }
    }

    const role = parseJwt(getLocalData('accessToken')).roles
    const isAdmin = role.some(item => item.name === "Super Admin")

    return (
        <>
            <tr className={`BasketsDuplicateRow ${expanded ? 'expanded' : ''}`}>
                <td>{basket_number}</td>
                <td>{basket_total_items ?? (docs[0] && docs[0].total_items) ?? ''}</td>
                <BasketLocation location={basket_location} />
                <td>{count || docs.length}</td>
                <td style={{ maxWidth: 320, whiteSpace: 'normal' }}>
                    {docIds.join(' | ')}
                </td>
                <td>
                    <Button size="small" onClick={onToggle} style={{ marginRight: 6 }}>
                        {expanded ? 'Thu gọn' : 'Xem chi tiết'}
                    </Button>
                </td>
            </tr>

            {expanded && (
                <tr className='BasketsDuplicateDetailsRow'>
                    <td colSpan={7} style={{ padding: 0, background: '#fffef8' }}>
                        <div style={{ overflowX: 'auto' }}>
                            <table className="inner-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Số giỏ</th>
                                        <th>Mã đơn</th>
                                        <th>Loại sản phẩm</th>
                                        <th>Loại đơn</th>
                                        <th>Loại giỏ</th>
                                        <th className='text-center'>Chưa hoàn thành / Đã hoàn thành</th>
                                        <th>Địa chỉ</th>
                                        <th>Trạng thái</th>
                                        <th>Ngày tạo</th>
                                        <th>Ngày hoàn thành</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {docs.map(d => {
                                        const { max_overtime } = d || {}
                                        const isWarning = max_overtime !== null && max_overtime !== undefined && !isNaN(max_overtime) && max_overtime >= -1.5
                                        const isOvertimed = !!isWarning && max_overtime > 0
                                        const isAlmostOvertime = !!isWarning && max_overtime >= -1.5 && max_overtime <= 0
                                        const wraningStyle = !!isWarning ? { background: `rgb(${(!!isAlmostOvertime ? "255, 208, 26, 0.3" : (isOvertimed ? "223, 31, 31, 0.2" : ''))})` } : {}
                                        return <tr key={d._id} style={wraningStyle}>
                                            <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{d._id}</td>
                                            <td className='BasketNumber'>
                                                <Link to={`/baskets/${d._id}`}>
                                                    {d.number}
                                                </Link>
                                            </td>

                                            <td className='BasketOrderNumber' style={{ maxWidth: 250 }}>
                                                {Array.isArray(d.order_numbers) &&
                                                    !!d.order_numbers.length ? d.order_numbers.map(i => `#${i}`).join(", ") :
                                                    !!d.order_number ? `#${d.order_number}` : '--'
                                                }
                                            </td>
                                            <BaskItemTypes types={d.item_types} />
                                            <td>{d.total_items}</td>
                                            <td>{!!d.type && renderTypeBasket(d.type)}</td>
                                            <BasketCompletedItem totalItems={d.total_items} completedItems={d.completed_items} />
                                            <BasketLocation location={d.location} />
                                            <BasketStatus status={d.status} />
                                            <BasketCreated created={d.initialized_at} />
                                            <td>{d.completed_at ? humanizeTime(d.completed_at) : '-'}</td>
                                            <td>
                                                {isAdmin &&
                                                    <Button
                                                        icon='delete'
                                                        disabled={loadingAction || !isAdmin}
                                                        type={'danger'}
                                                        onClick={() => attemptDeleteBasket(d)}
                                                    >
                                                        Xóa giỏ
                                                    </Button>
                                                }
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </td>
                </tr>
            )}
        </>
    )
}

BasketsDuplicateRow.propTypes = {
    group: PropTypes.object.isRequired,
    expanded: PropTypes.bool,
    onToggle: PropTypes.func,
    onExport: PropTypes.func
}
